import React from "react";


export const ConfigCells = ({ isConfig, cellImage, row, col, numCols, numRows, soh, cellId }) => {
  const volts = [3.4, 3.5, 3.6, 3.7];
  const isFirstInRow = col === 0;
  const isInLastRow = row === numRows - 1;

  const handleShowCellDetails = (id) => {
    window.open(`/auth/cellStore/${id}`, "_blank");
  };

  const createSvg = (soh) => {
    const sohValue = parseFloat(soh.replace("%", ""));
    const fillWidth = (sohValue / 100) * 1292; 
    const remainingWidth = 1292 - fillWidth;
  
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80%"
        height="80%"
        viewBox="0 0 1792 1792"
        id="battery"
        style={{ zIndex: 7, position: 'relative' }}
        className="battery-svg"
        onClick={() => handleShowCellDetails(cellId)}
      >
        <defs>
          <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#008000" />
          </linearGradient>
          <linearGradient id="redGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#FFFF00" />
          </linearGradient>
        </defs>
        <path
          fill="black"
          d="M224.111 1172.889V615.556H896v557.333H224.111zm1468.333-507.556q41.223 0 70.39 29.167Q1792 703.667 1792 744.889v298.667q0 41.222-29.167 70.388-29.166 29.167-70.389 29.167v124.445q0 51.333-36.555 87.888Q1619.333 1392 1568 1392H124.444q-51.333 0-87.888-36.556Q0 1318.89 0 1267.556V520.889q0-51.334 36.556-87.89 36.555-36.555 87.888-36.555H1568q51.333 0 87.889 36.556 36.555 36.555 36.555 87.889v124.444z"
        ></path>
        <path
          fill="white"
          d="M199.111 1192.889V595.556H896v597.333H199.111zm1493.333-547.556q41.223 0 70.39 29.167Q1792 703.667 1792 744.889v298.667q0 41.222-29.167 70.388-29.166 29.167-70.389 29.167v124.445q0 51.333-36.555 87.888Q1619.333 1392 1568 1392H124.444q-51.333 0-87.888-36.556Q0 1318.89 0 1267.556V520.889q0-51.334 36.556-87.89 36.555-36.555 87.888-36.555H1568q51.333 0 87.889 36.556 36.555 36.555 36.555 87.889v124.444zm0 398.223V744.889h-99.555v-224q0-10.89-7-17.89T1568 496H124.444q-10.888 0-17.888 7-7 7-7 17.89v746.667q0 10.888 7 17.888 7 7 17.888 7H1568q10.889 0 17.889-7t7-17.888v-224h99.555z"
        ></path>
        <rect
          x="199.111"
          y="595.556"
          width={fillWidth}
          height="607.333"
          fill="url(#greenGradient)"
        />
        <rect
          x={199.111 + fillWidth}
          y="595.556"
          width={remainingWidth}
          height="607.333"
          fill="url(#redGradient)"
        />
      </svg>
    );
  };

  return isConfig ? (
    <div className="mybox">
      <div className="mybox">
        <img src={cellImage} style={{ width: "100%", backgroundColor: "black" }} />
      </div>
    </div>
  ) : (
    <div className="mybox">
      <div className="relative flex flex-col items-center">
        {createSvg(soh)}
        <div className="my_centered flex flex-col font-bold bottom-[37%]">
          {/* {volts[Math.floor(Math.random() * volts.length)]} V, 5Ah, 72g */}
          SoH = {soh}
          <div onClick={() => handleShowCellDetails(cellId)} className="underline text-blue">
            See Data
          </div>
        </div>
        <div className="hr absolute bottom-[49%]"></div>
        {!isFirstInRow && !isInLastRow && (
          <div className="vr absolute left-[-1%] top-[50%] h-[169px]"></div>
        )}
      </div>
      {/* <center>
        Cell SoH = {soh}%;{" "}
        <a href="cellCharacteristic.html" style={{ backgroundColor: "black" }} target="_blank">
          See Data
        </a>
      </center> */}
    </div>
  );
};
